var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content", staticStyle: { "margin-left": "10px" } },
      [
        _c("search-item", {
          ref: "searchItem",
          attrs: {
            "config-module": "210101",
            "show-more-scheme": true,
            "show-simple": false,
            "expand-adv": true,
            "custom-sim-query-placeholder":
              _vm.$t("CargoMsg.Cargo_PlsInput") + _vm.$t("Pricing.FileName"),
            "sim-url": "",
            "adv-url": "",
            "custom-search-items": _vm.customSearchItems
          },
          on: { query: _vm.toQuery }
        }),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              attrs: {
                "config-module": "151115",
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination-wrapper" },
          [
            _c("cargo-pagination", {
              attrs: {
                "config-module": "151114",
                total: _vm.pageConditions.total,
                page: _vm.pageConditions.pageNum,
                limit: _vm.pageConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.pageConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.pageConditions, "pageSize", $event)
                },
                pagination: _vm.toQuery
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }